import { useCallback } from 'react';

import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { useHost } from '@xing-com/crate-xinglet';

type UseRedirectToLoginResult = {
  isLoggedOut: boolean;
  redirectToLogin: () => void;
};

export const useUserLoginState = (): UseRedirectToLoginResult => {
  const { isLoggedOut } = useLoginState();
  const { isPreview } = useHost();

  const redirectToLogin = useCallback((): void => {
    const loginLink = isPreview
      ? 'https://login.preview.xing.com'
      : 'https://login.xing.com/';

    window.location.href = loginLink;
  }, [isPreview]);

  return {
    isLoggedOut,
    redirectToLogin,
  };
};
